import { useNavigate } from "react-router-dom";
import { i18n } from "../../lang/i18n";

export default function CartDeliverPayWasKo() {
    const navigate = useNavigate();
    function goHome(){
        navigate('/deliver_orders')
    }
    return <div className="modal fade show">
        <div className="modal-dialog  modal-dialog-centered">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title">{i18n.PaymentKo.Title}</h5>
                    <button type="button" className="close" onClick={() => goHome()}  >
                        <i className="far fa-times-circle" />
                    </button>
                </div>
                <div className="modal-body">
                    <p>{i18n.PaymentKo.Message}</p>
                    <p>{i18n.PaymentKo.MessagePay}</p>
                </div>
                <div className="box p-3 text-center">
                    <button className="btn btn-warning" style={{ minWidth: 250 }}
                        onClick={() => goHome()}><i className="fa fa-check mr-2" />
                        {i18n._BTNs.Continue}
                    </button>
                </div>
            </div>
        </div>
    </div>
}